/**
 * Desktop header pill: ghost hints with typewriter + backspace between lines.
 * predictive-search.ka-header-search — see king-ape-header.liquid.
 */
(function () {
  var TYPE_MS = 42;
  var DELETE_MS = 28;
  var PAUSE_AFTER_FULL_MS = 1600;
  var PAUSE_AFTER_CLEAR_MS = 450;
  var REDUCE_ROTATE_MS = 5000;

  function readSuggestions(root) {
    var s1 = root.getAttribute('data-suggestion-1');
    var s2 = root.getAttribute('data-suggestion-2');
    var s3 = root.getAttribute('data-suggestion-3');
    return [s1, s2, s3].filter(function (s) {
      return s && String(s).trim().length;
    });
  }

  function setup(root) {
    var suggestions = readSuggestions(root);
    if (!suggestions.length) return;

    var input = root.querySelector('input[type="search"]');
    var ghost = root.querySelector('.ka-header-search-pill__ghost');
    var textEl = ghost && ghost.querySelector('.ka-header-suggestive__text');
    if (!input || !ghost || !textEl) return;

    var index = 0;
    var animationTimer = null;
    var reduceInterval = null;
    var charIndex = 0;
    var currentFull = '';

    var prefersReduce =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function ghostShouldShow() {
      return !String(input.value || '').trim() && document.activeElement !== input;
    }

    function clearAllTimers() {
      if (animationTimer !== null) {
        clearTimeout(animationTimer);
        animationTimer = null;
      }
      if (reduceInterval !== null) {
        clearInterval(reduceInterval);
        reduceInterval = null;
      }
    }

    function tickType() {
      if (!ghostShouldShow()) {
        textEl.textContent = '';
        return;
      }
      if (charIndex < currentFull.length) {
        textEl.textContent = currentFull.slice(0, charIndex + 1);
        charIndex += 1;
        animationTimer = window.setTimeout(tickType, TYPE_MS);
      } else {
        animationTimer = window.setTimeout(tickDelete, PAUSE_AFTER_FULL_MS);
      }
    }

    function tickDelete() {
      if (!ghostShouldShow()) {
        textEl.textContent = '';
        return;
      }
      var cur = textEl.textContent;
      if (cur.length > 0) {
        textEl.textContent = cur.slice(0, -1);
        animationTimer = window.setTimeout(tickDelete, DELETE_MS);
      } else {
        index = (index + 1) % suggestions.length;
        animationTimer = window.setTimeout(runTypewriterLoop, PAUSE_AFTER_CLEAR_MS);
      }
    }

    function runTypewriterLoop() {
      if (!ghostShouldShow()) {
        textEl.textContent = '';
        return;
      }
      currentFull = suggestions[index] || '';
      charIndex = 0;
      textEl.textContent = '';
      if (!currentFull.length) {
        index = (index + 1) % suggestions.length;
        animationTimer = window.setTimeout(runTypewriterLoop, PAUSE_AFTER_CLEAR_MS);
        return;
      }
      tickType();
    }

    function startReducedMotion() {
      function apply() {
        if (!ghostShouldShow()) return;
        textEl.textContent = suggestions[index] || '';
      }
      apply();
      reduceInterval = window.setInterval(function () {
        if (!ghostShouldShow()) return;
        index = (index + 1) % suggestions.length;
        apply();
      }, REDUCE_ROTATE_MS);
    }

    function sync() {
      var show = ghostShouldShow();
      ghost.hidden = !show;
      ghost.setAttribute('aria-hidden', 'true');
      clearAllTimers();
      if (show) {
        if (prefersReduce) {
          startReducedMotion();
        } else {
          runTypewriterLoop();
        }
      } else {
        textEl.textContent = '';
      }
    }

    input.addEventListener('input', sync);
    input.addEventListener('focus', sync);
    input.addEventListener('focusin', sync);
    input.addEventListener('blur', function () {
      window.requestAnimationFrame(sync);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
  }

  document.querySelectorAll('predictive-search.ka-header-search').forEach(setup);
})();
